// Static character & family data — easy to edit later without changing layouts.
export const SALTIE_BRAYS = [
  {
    slug: "bonnie",
    name: "Bonnie",
    role: "The calm and loving mama donkey",
    intro:
      "Bonnie is the calm and loving mama donkey who guides the other Brays through life with patience, reassurance, wisdom, and unconditional love. She represents emotional safety and the comforting reminder that growth happens gently. Bonnie is Shadow's mother — mother and foal, always close — and her best friend is Mae Mae, side-by-side through every season.",
  },
  {
    slug: "shadow",
    name: "Shadow",
    role: "Curious, goofy, and always growing",
    intro:
      "Shadow is curious, goofy, emotionally expressive, adventurous, sensitive, hopeful, and always growing. Through muddy puddles, zoomies, mistakes, laughter, and everyday adventures, Shadow learns how to recognize the Saltie Winks\u2122 all around her. Her stories help children understand: mistakes are part of learning, bravery can happen slowly, and belonging takes time. Bonnie is her mama — mother and foal — and Snickers is her best friend, a giggling and zooming pair.",
  },
  {
    slug: "mae-mae",
    name: "Mae Mae",
    role: "Thoughtful, observant, quietly wise",
    intro:
      "Mae Mae is thoughtful, observant, peaceful, and quietly wise. She notices the little things others sometimes miss and gently reminds the Lil Salties\u2122 that wisdom often whispers softly. Bonnie is her best friend — the two are almost always together.",
  },
  {
    slug: "snickers",
    name: "Snickers",
    role: "Affectionate, playful, emotionally warm",
    intro:
      "Snickers is affectionate, playful, loving, and emotionally warm. She represents comfort, closeness, joyful connection, and loving others freely. Shadow is her best friend — a zoomie-loving, giggle-filled, inseparable pair.",
  },
];

export const SALTIE_MOOS = [
  {
    slug: "glory",
    name: "Glory",
    role: "The emotional matriarch",
    intro:
      "Glory is the emotional matriarch of the Saltie Moos. She is wise, nurturing, calm, emotionally grounded, steady, and quietly strong. Glory teaches the Lil Salties\u2122 that love does not always need to be loud to be powerful. Sometimes the greatest Saltie Winks\u2122 arrive through peaceful hearts. She and Grace are inseparable — a pair you almost never see apart.",
  },
  {
    slug: "grace",
    name: "Grace",
    role: "Soft-hearted and reassuring",
    intro:
      "Grace is soft-hearted, patient, emotionally calming, and reassuring. She teaches that trust grows slowly and gentleness matters. She and Glory are inseparable — a pair you almost never see apart.",
  },
  {
    slug: "winnie-the-moo",
    name: "Winnie the Moo",
    role: "Joy, laughter, playful energy",
    intro:
      "Winnie brings joy, laughter, silliness, delight, and playful energy to the pasture. She reminds children that mistakes are survivable and joy can help heal hearts. Winnie belongs to the herd's inseparable BFF Moo Crew — Churro, Biscuit, Winnie the Moo, and Cinnamon — four friends who spend every day together.",
  },
  {
    slug: "biscuit",
    name: "Biscuit",
    role: "Shy, sensitive, small but brave",
    intro:
      "Biscuit represents shy and sensitive children. Through small but brave moments, Biscuit teaches that courage does not always need to be loud. Biscuit belongs to the herd's inseparable BFF Moo Crew — Churro, Biscuit, Winnie the Moo, and Cinnamon — four friends who spend every day together.",
  },
  {
    slug: "churro",
    name: "Churro",
    role: "Dependable strength and calm support",
    intro:
      "Churro represents dependable strength, emotional steadiness, protection, and calm support. He teaches children that gentle hearts can still be strong. Churro belongs to the herd's inseparable BFF Moo Crew — Churro, Biscuit, Winnie the Moo, and Cinnamon — four friends who spend every day together.",
  },
  {
    slug: "boomer",
    name: "Boomer",
    role: "Coming Soon",
    intro: "A new face joining the herd soon. His story is still being written.",
  },
  {
    slug: "cinnamon",
    name: "Cinnamon",
    role: "Coming Soon",
    intro:
      "Another sweet new addition on the way. More about her in the next chapter — though we already know Cinnamon belongs to the herd's inseparable BFF Moo Crew alongside Churro, Biscuit, and Winnie the Moo, four friends who spend every day together.",
  },
];

export const FAMILY = [
  {
    slug: "stefanie",
    name: "Stefanie",
    role: "Author & Storyteller — learning alongside the animals",
    intro:
      "Author, storyteller, and creator of The Salty Moo. Alongside Mike, Stefanie is learning that God isn't only teaching from a Sunday church pew — He's also teaching in the pasture, along the fence lines, through changing seasons, and through the animals themselves.",
  },
  {
    slug: "mike",
    name: "Mike (G'Pa)",
    role: "Steady heart of the herd — learning alongside the animals",
    intro:
      "Known as G'Pa, Mike serves alongside his family caring for the herd. Alongside Stefanie, he's learning that God isn't only teaching from a Sunday church pew — He's also teaching in the pasture, along the fence lines, through changing seasons, and through the animals themselves.",
  },
  {
    slug: "tyler",
    name: "Tyler",
    role: "Always lending a hand",
    intro:
      "Always willing to lend a helping hand and spend time with the animals. Tyler enjoys making memories with family and encouraging others.",
  },
  {
    slug: "alexis",
    name: "Alexis",
    role: "Creative & compassionate",
    intro:
      "Creative, compassionate, and always ready for the next adventure. Alexis loves sharing laughter, family, and life on the farm.",
  },
  {
    slug: "ethan",
    name: "Ethan",
    role: "Faithful friend",
    intro:
      "A faithful friend to the family who enjoys helping wherever needed and sharing in everyday farm adventures.",
  },
  {
    slug: "saylor",
    name: "Saylor",
    role: "Princess at heart",
    intro:
      "A princess at heart who loves imagination, sparkle, and spending time with the herd.",
  },
  {
    slug: "dawson",
    name: "Dawson",
    role: "Ready for adventure",
    intro:
      "Always ready for fun, adventure, and a good laugh. Dawson reminds everyone that childhood is meant to be enjoyed.",
  },
];

export const CHAPTERS = [
  { path: "/", label: "Welcome", short: "1" },
  { path: "/his-story", label: "His Story, Our Yes", short: "2" },
  { path: "/lil-salties", label: "Lil Salties", short: "3" },
  { path: "/meet-the-herd", label: "Meet the Herd", short: "4" },
  { path: "/looking-for-new-pastures", label: "Looking for New Pastures", short: "4a" },
  { path: "/saltie-brays", label: "Saltie Brays", short: "5" },
  { path: "/saltie-moos", label: "Saltie Moos", short: "6" },
  { path: "/saltie-winks", label: "Saltie Winks", short: "7" },
  { path: "/saltie-shout-outs", label: "Saltie Shout-Outs", short: "8" },
  { path: "/our-cow-munity", label: "Our Cow-munity", short: "9" },
  { path: "/moo-velous", label: "Caught Something Moo-velous?", short: "10" },
  { path: "/meet-the-family", label: "Meet the Family", short: "11" },
  { path: "/saltie-fun-facts", label: "Saltie Fun Facts", short: "12" },
  { path: "/front-porch", label: "Front Porch Swing", short: "13" },
  { path: "/salt-block", label: "The Salt Block", short: "14" },
  { path: "/story-barn", label: "The Story Barn", short: "15" },
];

export const STORY_BARN_ITEMS = [
  {
    slug: "first-book",
    title: "The Salty Moo — Book One",
    kind: "Picture Book",
    note: "The very first storybook adventure from the pasture.",
    status: "coming-soon",
  },
  {
    slug: "coloring-pages",
    title: "Saltie Coloring Pages",
    kind: "Printable",
    note: "Free downloadable coloring pages for little hands.",
    status: "coming-soon",
  },
  {
    slug: "mercantile-tee",
    title: "Saltie Moos Tee",
    kind: "Mercantile",
    note: "Soft tee featuring the Saltie Moos herd.",
    status: "coming-soon",
  },
  {
    slug: "read-aloud",
    title: "Read-Aloud Experience",
    kind: "Audio",
    note: "Cozy bedtime listening from Stefanie herself.",
    status: "coming-soon",
  },
  {
    slug: "audiobook",
    title: "The Salty Moo Audiobook",
    kind: "Audio",
    note: "Settle in. The pasture is waiting.",
    status: "coming-soon",
  },
  {
    slug: "activities",
    title: "Printable Activity Pack",
    kind: "Printable",
    note: "Mazes, matching, and gentle Scripture journaling.",
    status: "coming-soon",
  },
  {
    slug: "qr",
    title: "QR Pasture Experiences",
    kind: "Digital",
    note: "Scan a tag and meet the herd in a new way.",
    status: "coming-soon",
  },
  {
    slug: "devotional",
    title: "Family Devotional Companion",
    kind: "Book",
    note: "Walking through Scripture, one pasture story at a time.",
    status: "coming-soon",
  },
];
